module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r9r7n4r-e87c82b3845677d00e37e6e312156507.svg";